import { render, staticRenderFns } from "./VillageDetails.vue?vue&type=template&id=11dae478&scoped=true&"
import script from "./VillageDetails.vue?vue&type=script&lang=js&"
export * from "./VillageDetails.vue?vue&type=script&lang=js&"
import style0 from "./VillageDetails.vue?vue&type=style&index=0&id=11dae478&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dae478",
  null
  
)

export default component.exports